import React, { ReactNode, CSSProperties } from "react";
import { cn } from "@/libs/utils";

type TypographyProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export const Heading1 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[26px] font-500 leading-[32px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Heading2 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[24px] font-500 leading-[30px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Heading3 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[22px] font-700 leading-[28px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Subtitle1 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[20px] font-500 leading-[28px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Subtitle2 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[18px] font-500 leading-[24px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Subtitle3 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[16px] font-500 leading-[24px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Subtitle4 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[14px] font-500 leading-[24px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Subtitle5 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[13px] font-500 leading-[16px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Subtitle6 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[12px] font-700 leading-[16px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Subtitle7 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[12px] font-500 leading-[16px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Subtitle8 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[11px] font-700 leading-[14px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Subtitle9 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[10px] font-500 leading-[11px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Body1 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[16px] font-400 leading-[24px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Body2 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[14px] font-400 leading-[20px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Body3 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[13px] font-400 leading-[16px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Body4 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[12px] font-400 leading-[16px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Body5 = ({ children, className, style }: TypographyProps) => (
  <div
    className={cn("text-[10px] font-400 leading-[14px]", className)}
    style={style}
  >
    {children}
  </div>
);

export const Button1 = ({ children, className, style }: TypographyProps) => (
  <span
    className={cn("text-[16px] font-500 leading-[24px]", className)}
    style={style}
  >
    {children}
  </span>
);

export const Button2 = ({ children, className, style }: TypographyProps) => (
  <span
    className={cn("text-[14px] font-500 leading-[24px]", className)}
    style={style}
  >
    {children}
  </span>
);

export const Button3 = ({ children, className, style }: TypographyProps) => (
  <span
    className={cn("text-[13px] font-400 leading-[16px]", className)}
    style={style}
  >
    {children}
  </span>
);

export const Number1 = ({ children, className, style }: TypographyProps) => (
  <span
    className={cn("text-[28px] font-500 leading-[38px]", className)}
    style={style}
  >
    {children}
  </span>
);
